import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToCompra = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-navy-dark py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-40">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-41"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-42">
        <motion.h1 className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-43">
          Si tu estudio jurídico es un caos…{' '}
          <span className="text-gold" data-id="element-44">esto te va a doler</span>
        </motion.h1>

        <motion.p className="text-xl md:text-2xl text-gray-300 mb-12 font-medium" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-45">
          Si tu estudio depende de tu memoria… estás en problemas.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mb-12 cursor-pointer relative group inline-block" onClick={scrollToCompra} data-id="element-46">
          <div className="absolute inset-0 bg-gold/20 blur-xl rounded-full group-hover:bg-gold/30 transition-all duration-300" data-id="element-47"></div>
          <img src="https://cdn.magicpatterns.com/uploads/fy79wuSYUogRN224kaC9Zw/MOCKUP_PNG.png" alt="Estudio Jurídico Listo" className="w-full max-w-lg mx-auto relative z-10 drop-shadow-2xl group-hover:scale-105 transition-transform duration-300" data-id="element-48" />
        </motion.div>

        <CTAButton data-id="element-49" />
      </div>
    </section>;
}